import * as React from 'react'
import { useMemo, ReactElement } from 'react'
import PropTypes from 'prop-types'
import ImageEye from '@material-ui/icons/RemoveRedEye'
import { Link } from 'react-router-dom'
import { linkToRecord, Record, useResourceContext } from 'ra-core'

import Button, { ButtonProps } from './Button'

const defaultIcon = <ImageEye />
const stopPropagation = (e) => e.stopPropagation()

const ShowButton = (props: ShowButtonProps) => {
  const {
    basePath = '',
    icon = defaultIcon,
    label = 'ra.action.show',
    record,
    scrollToTop = true,
    ...rest
  } = props
  const resource = useResourceContext()
  return (
    <Button
      component={Link}
      to={useMemo(
        () => ({
          pathname: record
            ? `${linkToRecord(basePath || `/${resource}`, record.id)}/show`
            : '',
          state: { _scrollToTop: scrollToTop },
        }),
        [basePath, record, resource, scrollToTop],
      )}
      label={label}
      onClick={stopPropagation}
      {...(rest as any)}
    >
      {icon}
    </Button>
  )
}

interface Props {
  basePath?: string
  icon?: ReactElement
  label?: string
  record?: Record
  scrollToTop?: boolean
}

export type ShowButtonProps = Props & ButtonProps

ShowButton.propTypes = {
  basePath: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  record: PropTypes.any,
  scrollToTop: PropTypes.bool,
}

export default ShowButton
